import { createSafeContext } from 'ui';

type MapLocationContext = {
  lat: number;
  lng: number;
};

const [MapLocationProvider, useMapLocation] = createSafeContext<MapLocationContext>(
  'MapLocationContext not found'
);

export { MapLocationProvider, useMapLocation };
